export function co2ofTrees(trees) {
  var response = 0
  trees.forEach(tree => {
    response += co2ofTree(tree)
  });
  return response
}

export function co2ofTree(tree) {
  return 390
}


// WEBPACK FOOTER //
// ./src/utils/tree.js